import "./styles.less";

import * as React from "react";

import { MouseEvent, useContext, useEffect, useRef, useState } from "react";
import { OwnerPhoneInterface, usePhoneButton } from "./hook";

import { ModalPhone } from "../../../ModalPhone/web";
import { PhoneOutlined, PhoneFilled } from "@ant-design/icons";
import { useFacebookPixel } from "../../../../../GlobalHooks/web/FacebookPixel.hook";
import { useTheme } from "../../../../../Styles/ThemeHook";
import { Typography } from "antd";
import { ConfigStateContext } from "../../../../../Contexts/Configurations/context";
import { ModalState } from "../../TextForm/type";
import { useUser } from "shared-components/Components/User/User.hook";
import { getCountryCallingCode } from "libphonenumber-js";
import { LoadingIcon } from "shared-components/Components/CustomIcons/LoadingIcon/LoadingIcon";
import { useContactModal } from "shared-components/Contexts/ContactModal/context";
import { getInitialContactForm, requiresContactData } from "src/utils/Functions";
import { phoneRegion } from "@Utils/phones";

export const getInitCountryCode = () => {
	const countryCode = localStorage.getItem("selectedCountryCode");
	return countryCode ? JSON.parse(countryCode) : { code: "", value: "" };
};

export const PhoneButton = ({
	id,
	type = "callButton",
	color = null,
	disabled = false,
	seller = false,
	queryRouter,
	icon = false,
	forceState = ModalState.DEFAULT,
	owner,
	isProject = false,
	hasAcceptedTerms = true,
	onTermsError,
	onBeforeAction,
	callback,
	handleCloseContactModal = null,
	source = "",
	shouldAskForData
}: OwnerPhoneInterface) => {
	if (!owner || !owner?.masked_phone) return null;

	const { theme } = useTheme();
	const { country_code } = useContext(ConfigStateContext);
	const { ctaButtons, formData } = useContactModal();
	const {
		isLoggedIn,
		user: { data: dataUser },
	} = useUser();

	const callPhone = useRef(null);
	const FP = useFacebookPixel();
	const [selectedCountryCode, setSelectedCountryCode] = useState({
		code: "",
		value: "",
	});
	const contactForm = getInitialContactForm(isLoggedIn, dataUser);

	const evalPhone = () => {
		if (formData && formData.phone.length > 5) {
			return selectedCountryCode.value + formData.phone;
		}
		else if (contactForm && contactForm.phone.includes('+')) {
			return contactForm.phone;
		}
		return selectedCountryCode.value + contactForm.phone;
	}

	const { viewPhone, phone, loading, userExistsQuery } = usePhoneButton({
		property_id: id,
		seller,
		isProject,
		email: contactForm?.email,
		phone: evalPhone(),
		name: contactForm?.name,
	});
	const [modal, setModal] = useState(false);
	const [phoneData, setPhoneData] = useState(null);
	const isDisabled = disabled
	const isPrimaryButton = ctaButtons?.phone && !ctaButtons?.contact && !ctaButtons?.whatsapp && source === "contactModal"

	const askForData = shouldAskForData;
	const askDataBeforeContact = requiresContactData(country_code);

	useEffect(() => {
		if (forceState == ModalState.CLOSE) {
			setModal(false);
		} else if (forceState == ModalState.OPEN) {
			setModal(true);
		}
	}, [forceState]);

	useEffect(() => {
		if (country_code) {
			setSelectedCountryCode({
				code: phoneRegion(country_code),
				value: `+${getCountryCallingCode(phoneRegion(country_code))}`,
			})
		}
	}, [country_code]);

	// Simula el click de ver "Telefono"
	useEffect(() => {
		setTimeout(() => {
			if (queryRouter && queryRouter === "call") {
				if (callPhone.current) callPhone.current.click();
			}
		}, 3000);
	}, [queryRouter]);

	const makePhoneCall = phoneNumber => {
		if (phoneNumber) {
			window.location.href = `tel:${phoneNumber}`;
			return true;
		}
		return false;
	};

	const sendEvent = () => {
		const categoryName: string = "Consultas Tel";
		FP.StandardEvent(categoryName);
	};

	const handlePhoneCall = (res: any) => {
		if ('data' in res && res.data) {
			sendEvent();
			const phone = res.data.requestPhoneAgent[0]?.phone ?? ''
			const firstNumberPhone = phone!=='' ? phone.split(';')[0] : ''
			makePhoneCall(firstNumberPhone);
			setPhoneData(res);
			setModal(true);
		}
	};

	const handleClick = async (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
	
		if (!askDataBeforeContact) {
			const res = await viewPhone();
			handlePhoneCall(res);
			return;
		}
	
		if (askForData) {
			callback({ctaButtons: {
				contact: false,
				phone: true,
				whatsapp: false
			}});
			return;
		}
	
		if (!isLoggedIn &&  contactForm?.email?.length) {
			userExistsQuery({ variables: { email: contactForm.email } });
		}

		if (phoneData) {
			sendEvent();
			makePhoneCall(phoneData.data.requestPhoneAgent[0]?.phone);
			setModal(true);
			return;
		}
	
		const res = await viewPhone();
		handlePhoneCall(res);
	};

	const viewPhoneBtn = (
		<div className="view-phone-btn">
			{icon && <PhoneOutlined style={{ color: color ?? theme.colors.linkColor }} />}
			<Typography.Text className="masked">{owner?.masked_phone}</Typography.Text>
			{owner?.masked_phone && (
				<button
					ref={callPhone}
					onClick={(e: any) => {
						handleClick(e);
					}}
					className="secondary"
					disabled={isDisabled}
					style={{
						color : isDisabled ? "#92929D" : '',
						marginBottom: "4px"
					}}
				>
					{loading ? (
						<LoadingIcon classes="loading-icon" width={16} />
					) : null}
					Ver teléfono
				</button>
			)}
		</div>
	);

	const callBtn = (
		<button
			ref={callPhone}
			className={isPrimaryButton ? "btn-primary btn-modal" : "phone-button"}
			onClick={e => {
				if (onBeforeAction && !onBeforeAction(e, "phone")) return;
				if (hasAcceptedTerms) {
					handleClick(e);
				} else {
					if (onTermsError) onTermsError(e);
				}
			}}
			disabled={isDisabled}
		>
			{loading ? (
				<LoadingIcon classes="loading-icon" width={16} />
			) : (
				<span className="btn-icon">
					{
						country_code === "ce3" ? (
							<PhoneFilled style={{ color: color ?? theme.colors.linkColor }} />
						) : (
							<PhoneOutlined />
						)
					}
				</span>
			)}
			<span className="btn-text">Llamar</span>
		</button>
	);

	return (
		<>
			{type == "callButton" ? callBtn : viewPhoneBtn}

			<ModalPhone
				visible={modal}
				loading={loading}
				onCancel={() => {
					if (handleCloseContactModal) {
						handleCloseContactModal();
					}
					setModal(false)
				}}
				owner_name={owner.name}
				owner={owner}
				phone={phone}
			/>
		</>
	);
};
